<template>
  <div>
    <First></First>
  </div>
</template>

<script>
  import Product from "@/components/product/Product";
  import About from "@/components/about/About";
  import Project from "@/components/project/Project";
  import Contact from "@/components/contact/Contact";
  import First from  "@/components/first/First";
  export default {
    name: "Home",
    components: {Contact, Project, About, Product,First},
  }
</script>

<style scoped>
  .product{
    /* height: 770px; */
    overflow: hidden;
  }
 .about{
   height: 644px;
   overflow: hidden;
 }
 @media screen and (max-width: 768px) {
  .about{
   /* height: 344px; */
   overflow: hidden;
 }
 }
</style>
